'use client'

import { ActionStatus } from '@/core/types/enums/action-status.enum'
import { addToast } from '@heroui/react'
import { useTransition } from 'react'
import { logoutAction } from '../../actions/logout.action'

type Props = {
  children: ((isPending: boolean) => React.ReactNode) | React.ReactNode
  onSuccess?: () => void
}

export const LogoutForm: React.FC<Props> = ({ children, onSuccess }) => {
  const [isPending, startTransition] = useTransition()

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault()
    startTransition(async () => {
      const { error, status } = await logoutAction()

      if (status === ActionStatus.SUCCESS) onSuccess?.()

      if (error) {
        addToast({
          title: error,
          color: 'danger',
        })
      }
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      {typeof children === 'function' ? children(isPending) : children}
    </form>
  )
}
